// extracted by mini-css-extract-plugin
module.exports = {"animate":"_2deea771","rotate-keyframes":"_6a09b357"};